import LegalInfo from 'components/summary/LegalInfo/styled';

export default LegalInfo;
